// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.survey {
    width: 100%;
    min-height: 100vh;
    background: linear-gradient(339deg, #EFF4FF 0%, #EBE4FF 100%), #FFFFFF;
    position: relative;
}

.bg {
    width: 100%;
}

.detail {
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    /* padding: 0 18px; */
    padding-top: 11px;
    padding-bottom: 50px;
}

.rw {
    width: 50%;
    height: 167px;
    margin-left: 8px;
}

.hint {
    width: 178px;
    height: 67px;
    background: rgba(255, 255, 255, 0.6);
    box-shadow: 0px 4px 8px 0px rgba(128, 3, 253, 0.06);
    border-radius: 20px 20px 20px 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 49px;
    left: 48%;
}

.hint_text {
    width: 150px;
    height: 40px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 13px;
    color: #000000;
    line-height: 22px;
    position: relative;

}

.icon1 {
    position: absolute;
    top: -6px;
    right: 32px;
    width: 20px;
    height: 18px;
}

.info {
    position: relative;
    margin: 0 auto;
    margin-top: -10px;
    width: 93%;
    min-height: 578px;
    background: #FFFFFF;
    border-radius: 20px 20px 20px 20px;
    /* overflow: scroll; */
    display: flex;
    align-items: center;
    /* justify-content: center; */
    flex-direction: column;
    padding: 22px 0;
}

.top_jindu {
    display: flex;
    align-items: center;
}

.now {
    margin-left: 15px;
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 14px;
    color: #333333;
    line-height: 23px;
}

.jindu_bg {
    width: 266px;
    height: 10px;
    background: #EFF4FF;
    border-radius: 20px 20px 20px 20px;
    border: 2px solid #DFDDFF;
    position: relative;
}

.jindu {
    position: absolute;
    top: -2px;
    left: -1px;
    width: 0;
    height: 10px;
    background: #32EA97;
    box-shadow: inset 0px -1px 0px 0px rgba(255, 255, 255, 0.64), 1px 0px 2px 0px rgba(0, 0, 0, 0.1);
    border-radius: 10px 10px 10px 10px;
    border: 2px solid #18CA79;
}


.next {
    width: 83vw;
    height: 53px;
    background: #D9D9D9;
    border-radius: 30px 30px 30px 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    bottom: 22px;
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 16px;
    color: #FFFFFF;
}

.next-a {
    background: #8003FD;
    box-shadow: inset 0px -4px 0px 0px rgba(45, 0, 168, 0.6), 0px 4px 4px 0px #CFCDFC;
}

.titlea {
    width: 80%;
    font-family: PingFang SC, PingFang SC;
    font-weight: 800;
    font-size: 18px;
    color: #000000;
    margin-top: 26px;
    -webkit-line-clamp: 2;
    /* 限制为两行 */
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
}

.selections {
    display: flex;
    flex-direction: column;
    margin-top: 28px;
}

.selection {
    width: 83vw;
    height: 53px;
    background: #FFFFFF;
    box-shadow: 0px 2px 0px 0px #CFCDFC, 0px 4px 2px 0px rgba(207, 205, 252, 0.3);
    border-radius: 30px 30px 30px 30px;
    border: 2px solid #CFCDFC;
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 15px;
    color: #000000;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 14px;
}

.selection-a {
    background: #EAE9FF;
    box-shadow: 0px 2px 0px 0px #CFCDFC, 0px 4px 2px 0px rgba(207, 205, 252, 0.3);
    border-radius: 30px 30px 30px 30px;
    border: 2px solid #CFCDFC;
}

.desc {
    margin-top: 10px;
    width: 241px;
    height: 34px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: rgba(51, 51, 51, 0.7);
    line-height: 22px;
    text-align: center;
    font-style: normal;
    text-transform: none;
}

.input_no {
    width: 288px !important;
    height: 53px;
    background: #FFFFFF;
    border-radius: 30px 30px 30px 30px;
    border: 2px solid #CFCDFC;
    margin-top: 23px;
    text-align: center;
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 15px;
    color: #000000;
}

.input-a {
    border: 2px solid #7F5FFF;
}

.input_no::placeholder {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: rgba(51, 51, 51, 0.3);
}`, "",{"version":3,"sources":["webpack://./src/survey/index.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,iBAAiB;IACjB,sEAAsE;IACtE,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,oCAAoC;IACpC,mDAAmD;IACnD,iCAAiC;IACjC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,SAAS;IACT,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,qCAAqC;IACrC,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,kBAAkB;;AAEtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,kCAAkC;IAClC,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,qCAAqC;IACrC,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,kCAAkC;IAClC,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,QAAQ;IACR,YAAY;IACZ,mBAAmB;IACnB,gGAAgG;IAChG,kCAAkC;IAClC,yBAAyB;AAC7B;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kCAAkC;IAClC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,qCAAqC;IACrC,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,iFAAiF;AACrF;;AAEA;IACI,UAAU;IACV,qCAAqC;IACrC,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,qBAAqB;IACrB,UAAU;IACV,oBAAoB;IACpB,4BAA4B;IAC5B,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,6EAA6E;IAC7E,kCAAkC;IAClC,yBAAyB;IACzB,qCAAqC;IACrC,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,6EAA6E;IAC7E,kCAAkC;IAClC,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,qCAAqC;IACrC,gBAAgB;IAChB,eAAe;IACf,4BAA4B;IAC5B,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;IACnB,kCAAkC;IAClC,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,qCAAqC;IACrC,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qCAAqC;IACrC,gBAAgB;IAChB,eAAe;IACf,4BAA4B;AAChC","sourcesContent":[".survey {\n    width: 100%;\n    min-height: 100vh;\n    background: linear-gradient(339deg, #EFF4FF 0%, #EBE4FF 100%), #FFFFFF;\n    position: relative;\n}\n\n.bg {\n    width: 100%;\n}\n\n.detail {\n    position: relative;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    /* padding: 0 18px; */\n    padding-top: 11px;\n    padding-bottom: 50px;\n}\n\n.rw {\n    width: 50%;\n    height: 167px;\n    margin-left: 8px;\n}\n\n.hint {\n    width: 178px;\n    height: 67px;\n    background: rgba(255, 255, 255, 0.6);\n    box-shadow: 0px 4px 8px 0px rgba(128, 3, 253, 0.06);\n    border-radius: 20px 20px 20px 0px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: absolute;\n    top: 49px;\n    left: 48%;\n}\n\n.hint_text {\n    width: 150px;\n    height: 40px;\n    font-family: PingFang SC, PingFang SC;\n    font-weight: 500;\n    font-size: 13px;\n    color: #000000;\n    line-height: 22px;\n    position: relative;\n\n}\n\n.icon1 {\n    position: absolute;\n    top: -6px;\n    right: 32px;\n    width: 20px;\n    height: 18px;\n}\n\n.info {\n    position: relative;\n    margin: 0 auto;\n    margin-top: -10px;\n    width: 93%;\n    min-height: 578px;\n    background: #FFFFFF;\n    border-radius: 20px 20px 20px 20px;\n    /* overflow: scroll; */\n    display: flex;\n    align-items: center;\n    /* justify-content: center; */\n    flex-direction: column;\n    padding: 22px 0;\n}\n\n.top_jindu {\n    display: flex;\n    align-items: center;\n}\n\n.now {\n    margin-left: 15px;\n    font-family: PingFang SC, PingFang SC;\n    font-weight: bold;\n    font-size: 14px;\n    color: #333333;\n    line-height: 23px;\n}\n\n.jindu_bg {\n    width: 266px;\n    height: 10px;\n    background: #EFF4FF;\n    border-radius: 20px 20px 20px 20px;\n    border: 2px solid #DFDDFF;\n    position: relative;\n}\n\n.jindu {\n    position: absolute;\n    top: -2px;\n    left: -1px;\n    width: 0;\n    height: 10px;\n    background: #32EA97;\n    box-shadow: inset 0px -1px 0px 0px rgba(255, 255, 255, 0.64), 1px 0px 2px 0px rgba(0, 0, 0, 0.1);\n    border-radius: 10px 10px 10px 10px;\n    border: 2px solid #18CA79;\n}\n\n\n.next {\n    width: 83vw;\n    height: 53px;\n    background: #D9D9D9;\n    border-radius: 30px 30px 30px 30px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: absolute;\n    bottom: 22px;\n    font-family: PingFang SC, PingFang SC;\n    font-weight: bold;\n    font-size: 16px;\n    color: #FFFFFF;\n}\n\n.next-a {\n    background: #8003FD;\n    box-shadow: inset 0px -4px 0px 0px rgba(45, 0, 168, 0.6), 0px 4px 4px 0px #CFCDFC;\n}\n\n.titlea {\n    width: 80%;\n    font-family: PingFang SC, PingFang SC;\n    font-weight: 800;\n    font-size: 18px;\n    color: #000000;\n    margin-top: 26px;\n    -webkit-line-clamp: 2;\n    /* 限制为两行 */\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    text-align: center;\n}\n\n.selections {\n    display: flex;\n    flex-direction: column;\n    margin-top: 28px;\n}\n\n.selection {\n    width: 83vw;\n    height: 53px;\n    background: #FFFFFF;\n    box-shadow: 0px 2px 0px 0px #CFCDFC, 0px 4px 2px 0px rgba(207, 205, 252, 0.3);\n    border-radius: 30px 30px 30px 30px;\n    border: 2px solid #CFCDFC;\n    font-family: PingFang SC, PingFang SC;\n    font-weight: bold;\n    font-size: 15px;\n    color: #000000;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 14px;\n}\n\n.selection-a {\n    background: #EAE9FF;\n    box-shadow: 0px 2px 0px 0px #CFCDFC, 0px 4px 2px 0px rgba(207, 205, 252, 0.3);\n    border-radius: 30px 30px 30px 30px;\n    border: 2px solid #CFCDFC;\n}\n\n.desc {\n    margin-top: 10px;\n    width: 241px;\n    height: 34px;\n    font-family: PingFang SC, PingFang SC;\n    font-weight: 500;\n    font-size: 14px;\n    color: rgba(51, 51, 51, 0.7);\n    line-height: 22px;\n    text-align: center;\n    font-style: normal;\n    text-transform: none;\n}\n\n.input_no {\n    width: 288px !important;\n    height: 53px;\n    background: #FFFFFF;\n    border-radius: 30px 30px 30px 30px;\n    border: 2px solid #CFCDFC;\n    margin-top: 23px;\n    text-align: center;\n    font-family: PingFang SC, PingFang SC;\n    font-weight: bold;\n    font-size: 15px;\n    color: #000000;\n}\n\n.input-a {\n    border: 2px solid #7F5FFF;\n}\n\n.input_no::placeholder {\n    font-family: PingFang SC, PingFang SC;\n    font-weight: 500;\n    font-size: 14px;\n    color: rgba(51, 51, 51, 0.3);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
